import React, { useEffect, useState } from 'react';
import { Button, Badge, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import Select from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import moment from 'moment';
import idly from '../../../../images/items/items.jpg';
import { toast } from 'react-toastify';

const AddWastage = ({ show, onClose, assignment, onSuccess }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const assignmentSno = assignment?.sno || null;

    const [staffList, setStaffList] = useState([]);
    const [loadingStaff, setLoadingStaff] = useState(true);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [itemInfo, setItemInfo] = useState({});
    const [productInfo, setProductInfo] = useState({});
    const [wastageAssignment, setWastageAssignment] = useState(null);

    const [formData, setFormData] = useState({
        delivered_quantity: '',
        balance_quantity: '',
        staff: [],
        average_production_cost: '',
        wastage_reason: ''
    });
    const [wastageType, setWastageType] = useState("food"); // "food" or "raw"
    useEffect(() => {
        axios.get(`${baseURL}/active-staff`)
            .then(res => {
                const options = res.data.data.map(staff => ({
                    value: staff.id,
                    label: staff.name
                }));
                setStaffList(options);
            })
            .catch(err => console.error("Failed to fetch staff", err))
            .finally(() => setLoadingStaff(false));
    }, []);

   
const fetchData = async () => {
    setLoading(true);
    try {
        const res = await axios.get(`${baseURL}/production-wastage/assignment/${assignmentSno}`);
        const data = res.data.data || {};

        setItemInfo(data.item_info || {});
        // setProductInfo((data.product_info || [])[0] || {});
        setProductInfo(data.product_info || []);

        setWastageAssignment(data.wastage_assignment || assignmentSno);

        const selectedStaff = Array.isArray(data.staff_info)
            ? staffList.filter(opt => data.staff_info.some(s => s.id === opt.value))
            : [];

        const deliveredQty = data.delivered_quantity || '';
        const totalQty = data.total_quantity || (data.product_info?.[0]?.quantity || 0);
        const balanceQty = totalQty - deliveredQty;

        setFormData({
            delivered_quantity: deliveredQty,
            balance_quantity: balanceQty >= 0 ? balanceQty.toFixed(2) : '',
            staff: selectedStaff,
            average_production_cost: data.average_production_cost || '',
            wastage_reason: data.wastage_reason || ''
        });

        // 🔗 Connect wastage_type to state
        // setWastageType(data.wastage_type || 'food');
           setWastageType(data.wastage_type === 1 ? "raw" : "food");

    } catch (error) {
        console.error("Error fetching wastage data:", error);
        setItemInfo(assignment?.item_info || {});
        // setProductInfo((assignment?.product_info || [])[0] || {});
         setProductInfo(assignment?.product_info || []);
        setWastageAssignment(assignmentSno);
    } finally {
        setLoading(false);
    }
};



    useEffect(() => {
        if (show && assignmentSno) fetchData();
    }, [show, assignmentSno, staffList]);

    // const handleSubmit = async () => {
    //     const newErrors = {};
    //     const validateNumber = (value, field) => {
    //         if (value === '') newErrors[field] = "This field is required";
    //         else if (isNaN(value) || Number(value) < 0) newErrors[field] = "Must be a non-negative number";
    //         else if (value.toString().length > 10) newErrors[field] = "Maximum 10 digits allowed";
    //     };

    //     const totalQty = parseFloat(productInfo.quantity || 0);

    //     validateNumber(totalQty, "total_quantity");
    //     validateNumber(formData.delivered_quantity, "delivered_quantity");
    //     validateNumber(formData.balance_quantity, "balance_quantity");
    //     validateNumber(formData.average_production_cost, "average_production_cost");

    //     if (!formData.staff || formData.staff.length === 0) newErrors.staff = "Please select at least one staff";
    //     if (!formData.wastage_reason) newErrors.wastage_reason = "This field is required";
    //     else if (formData.wastage_reason.length > 100) newErrors.wastage_reason = "Max 100 characters allowed";

    //     setErrors(newErrors);
    //     if (Object.keys(newErrors).length > 0) return;

    //     setSubmitting(true);

    //     const payload = {
    //         wastage_date: moment(assignment?.workassignment_date || new Date()).format("YYYY-MM-DD"),
    //         wastage_item: itemInfo.id,
    //         wastage_assignment: wastageAssignment,
    //         total_quantity: Number(totalQty),
    //         delivered_quantity: Number(formData.delivered_quantity),
    //         balance_quantity: Number(formData.balance_quantity),
    //         staff: formData.staff.map(s => s.value),
    //         average_production_cost: Number(formData.average_production_cost),
    //         wastage_reason: formData.wastage_reason,
    //         wastage_type: wastageType === "food" ? 0 : 1 // ✅ add this line
    //     };

    //     try {
    //         await axios.post(`${baseURL}/production-wastage`, payload);
    //         toast.success("Wastage Saved Successfully!");
    //         if (onSuccess) onSuccess();
    //         onClose();
    //     } catch (err) {
    //         console.error("Submit error:", err);
    //         toast.error(err.response?.data?.message || "Submission failed");
    //     } finally {
    //         setSubmitting(false);
    //     }
    // };
 
//  const handleSubmit = async () => {
//     const newErrors = {};
//     const validateNumber = (value, field) => {
//         if (value === '') newErrors[field] = "This field is required";
//         else if (isNaN(value) || Number(value) < 0) newErrors[field] = "Must be a non-negative number";
//         else if (value.toString().length > 10) newErrors[field] = "Maximum 10 digits allowed";
//     };

//     const totalQty = parseFloat(productInfo.quantity || 0);

//     validateNumber(totalQty, "total_quantity");
//     validateNumber(formData.delivered_quantity, "delivered_quantity");
//     validateNumber(formData.balance_quantity, "balance_quantity");

//     // ✅ Only require average_production_cost if wastageType is "food"
//     if (wastageType === "food") {
//         validateNumber(formData.average_production_cost, "average_production_cost");
//     }

//     if (!formData.staff || formData.staff.length === 0) {
//         newErrors.staff = "Please select at least one staff";
//     }
//     if (!formData.wastage_reason) {
//         newErrors.wastage_reason = "This field is required";
//     } else if (formData.wastage_reason.length > 100) {
//         newErrors.wastage_reason = "Max 100 characters allowed";
//     }

//     setErrors(newErrors);
//     if (Object.keys(newErrors).length > 0) return;

//     setSubmitting(true);

//     const payload = {
//         wastage_date: moment(assignment?.workassignment_date || new Date()).format("YYYY-MM-DD"),
//         wastage_item: itemInfo.id,
//         wastage_assignment: wastageAssignment,
//         total_quantity: Number(totalQty),
//         delivered_quantity: Number(formData.delivered_quantity),
//         balance_quantity: Number(formData.balance_quantity),
//         staff: formData.staff.map(s => s.value),
//         average_production_cost: Number(formData.average_production_cost),
//         wastage_reason: formData.wastage_reason,
//         wastage_type: wastageType === "food" ? 0 : 1
//     };

//     try {
//         await axios.post(`${baseURL}/production-wastage`, payload);
//         toast.success("Wastage Saved Successfully!");
//         if (onSuccess) onSuccess();
//         onClose();
//     } catch (err) {
//         console.error("Submit error:", err);
//         toast.error(err.response?.data?.message || "Submission failed");
//     } finally {
//         setSubmitting(false);
//     }
// };


const handleSubmit = async () => {
    const newErrors = {};
    const validateNumber = (value, field) => {
        if (value === '') newErrors[field] = "This field is required";
        else if (isNaN(value) || Number(value) < 0) newErrors[field] = "Must be a non-negative number";
        else if (value.toString().length > 10) newErrors[field] = "Maximum 10 digits allowed";
    };

    // ✅ Calculate total quantity from array
    const totalQty = Array.isArray(productInfo)
        ? productInfo.reduce((sum, item) => {
            const qty = parseFloat(item.cooking_quantity);
            return sum + (isNaN(qty) ? 0 : qty);
        }, 0)
        : 0;

    validateNumber(totalQty, "total_quantity");
    validateNumber(formData.delivered_quantity, "delivered_quantity");
    validateNumber(formData.balance_quantity, "balance_quantity");

    // ✅ Calculate per-unit cost if food wastage
    let avgProdCost = formData.average_production_cost;
    if (wastageType === "food") {
        // cost per unit = production_cost / quantity
        const perUnitCost = parseFloat(itemInfo.production_cost) / parseFloat(itemInfo.quantity || 1);
        avgProdCost = perUnitCost * parseFloat(formData.balance_quantity || 0);
        validateNumber(avgProdCost, "average_production_cost");
    }

    if (!formData.staff || formData.staff.length === 0) {
        newErrors.staff = "Please select at least one staff";
    }
    if (!formData.wastage_reason) {
        newErrors.wastage_reason = "This field is required";
    } else if (formData.wastage_reason.length > 100) {
        newErrors.wastage_reason = "Max 100 characters allowed";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setSubmitting(true);

    const payload = {
        wastage_date: moment(assignment?.workassignment_date || new Date()).format("YYYY-MM-DD"),
        wastage_item: itemInfo.id,
        wastage_assignment: wastageAssignment,
        total_quantity: Number(totalQty),
        delivered_quantity: Number(formData.delivered_quantity),
        balance_quantity: Number(formData.balance_quantity),
        staff: formData.staff.map(s => s.value),
        average_production_cost: Number(avgProdCost),
        wastage_reason: formData.wastage_reason,
        wastage_type: wastageType === "food" ? 0 : 1
    };

    try {
        await axios.post(`${baseURL}/production-wastage`, payload);
        toast.success("Wastage Saved Successfully!");
        if (onSuccess) onSuccess();
        onClose();
    } catch (err) {
        console.error("Submit error:", err);
        toast.error(err.response?.data?.message || "Submission failed");
    } finally {
        setSubmitting(false);
    }
};


useEffect(() => {
    const total = Array.isArray(productInfo)
        ? productInfo.reduce((sum, item) => {
            const qty = parseFloat(item.cooking_quantity);
            return sum + (isNaN(qty) ? 0 : qty);
        }, 0)
        : 0;

    const delivered = parseFloat(formData.delivered_quantity || 0);
    const costPerUnit = itemInfo?.production_cost && itemInfo?.quantity
        ? parseFloat(itemInfo.production_cost) / parseFloat(itemInfo.quantity)
        : 0;

    if (delivered > total) {
        setErrors(prev => ({
            ...prev,
            delivered_quantity: `Delivered quantity (${delivered}) cannot exceed total cooking quantity (${total.toFixed(2)})`
        }));

        setFormData(prev => ({
            ...prev,
            balance_quantity: '',
            average_production_cost: 0
        }));
    } else {
        const balance = total - delivered;
        const wastedCost = balance >= 0 ? (balance * costPerUnit).toFixed(2) : 0;

        setErrors(prev => ({
            ...prev,
            delivered_quantity: ''
        }));

        setFormData(prev => ({
            ...prev,
            balance_quantity: balance >= 0 ? balance.toFixed(2) : '',
            average_production_cost: wastedCost
        }));
    }
}, [productInfo, formData.delivered_quantity, itemInfo]);

    return (
        <Modal show={show} size="lg">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Add Wastage</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {!loading && (
                        <>
                            <div className="row mb-3">
                                <div className="col-lg-6">
                                    <div className="d-flex flex-row align-items-center justify-content-start gap-2">
                                        <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                                            <div data-src={itemInfo.image || idly} className='border rounded px-1 py-0'>
                                                <img src={itemInfo.image || idly} alt="Item" className='cursor-pointer w-90px h-90px' />
                                            </div>
                                        </LightGallery>
                                   
                                        <div className='d-flex flex-column align-items-start justify-content-start'>
                                            <label className='text-primary font-w500 fs-5'>
                                                {itemInfo.name} <span style={{ display: 'none' }}>{itemInfo.id}</span>
                                            </label>

                                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Item Category</span></Tooltip>} >
                                                <label className='text-gray-800 fs-7'>{itemInfo.category}</label>
                                            </OverlayTrigger>
                                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Item sub Category</span></Tooltip>} >
                                                <label className='text-gray-800 fs-7'>{itemInfo.sub_category}</label>
                                            </OverlayTrigger>
                                        </div> 
                                    </div>
                                </div>
                             
                            </div>
                            <div className="row mt-4">
                                <div className="col-lg-6 mb-4">
                                    <label className="text-black font-w500 fs-7">Wastage<span className="required">*</span></label>
                                    <div className='mt-2'>
                                        <div className="form-check-inline">
                                            <input
                                                type="radio"
                                                name="product_type"
                                                value="food"
                                                checked={wastageType === "food"}
                                                onChange={() => setWastageType("food")}
                                            />
                                            <label className="form-check-label fs-7">Food Wastage</label>
                                        </div>
                                        <div className="form-check-inline">
                                            <input
                                                type="radio"
                                                name="product_type" 
                                                value="raw"
                                                checked={wastageType === "raw"}
                                                onChange={() => setWastageType("raw")}
                                            />

                                            <label className="form-check-label fs-7">Raw Material Wastage</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                {wastageType === "raw" && (
                                <div className="col-lg-6 mb-2 d-flex flex-column gp-2">
                                    <label className="text-black font-w500 fs-7">Total Quantity<span className="required">*</span></label>
                                    <label className="text-danger font-w500 fs-6">{Array.isArray(productInfo) && productInfo.length > 0
                                            ? (() => {
                                                const unitMatch = productInfo[0].cooking_quantity.match(/[a-zA-Z]+/);
                                                const unit = unitMatch ? unitMatch[0] : '';
                                                const total = productInfo
                                                .reduce((sum, item) => {
                                                    const qty = parseFloat(item.cooking_quantity);
                                                    return sum + (isNaN(qty) ? 0 : qty);
                                                }, 0)
                                                .toFixed(2);
                                                return `${total} ${unit}`;
                                            })()    
                                            : '-'}</label>
                                </div>
                                )}
                                {wastageType === "food" && (
                                    <>
                                    <div className="col-lg-6 mb-2 d-flex flex-column gp-2">
                                        <label className="text-black font-w500 fs-7">Total Quantity<span className="required">*</span></label>
                                     <label className="text-danger font-w500 fs-6">
                                        {Array.isArray(productInfo) && productInfo.length > 0
                                            ? (() => {
                                                const unitMatch = productInfo[0].cooking_quantity.match(/[a-zA-Z]+/);
                                                const unit = unitMatch ? unitMatch[0] : '';
                                                const total = productInfo
                                                .reduce((sum, item) => {
                                                    const qty = parseFloat(item.cooking_quantity);
                                                    return sum + (isNaN(qty) ? 0 : qty);
                                                }, 0)
                                                .toFixed(2);
                                                return `${total} ${unit}`;
                                            })()    
                                            : '-'}
                                        </label>


                                    </div> 
                                    <div className="col-lg-6 mb-2 d-flex flex-column gp-2">
                                        <label className="text-black font-w500 fs-7">
                                            Total Cost | Product Cost (per {itemInfo.unit.slice(0, -1)})<span className="required">*</span>
                                        </label> 
                                       <label className="text-danger font-w500 fs-6">
                                            {(() => {
                                                const perUnit = parseFloat(itemInfo.production_cost) / parseFloat(itemInfo.quantity);
                                                const totalQty = Array.isArray(productInfo)
                                                    ? productInfo.reduce((sum, item) => {
                                                        const qty = parseFloat(item.cooking_quantity);
                                                        return sum + (isNaN(qty) ? 0 : qty);
                                                    }, 0)
                                                    : 0;
                                                const totalAmount = perUnit * totalQty;
                                                const unit = itemInfo.unit ? itemInfo.unit.slice(0, -1) : '';

                                                return `₹ ${totalAmount.toFixed(2)} | ₹ ${perUnit.toFixed(2)} (per ${unit})`;
                                            })()}
                                        </label>


                                    </div>

                                    </>
                                )}
                                <div className="col-lg-6 mb-2">
                                    <div className='row'>
                                        <div className="col-lg-6 mb-2">
                                            <label className="text-black font-w500 fs-7">Delivered Quantity<span className="required">*</span></label>
                                           
                                            <input
                                            type="number"
                                            className={`form-control ${errors.delivered_quantity ? 'is-invalid' : ''}`}
                                            value={formData.delivered_quantity}
                                            min="0"
                                            onChange={e => {
                                                const val = e.target.value.replace(/[^0-9.]/g, '').slice(0, 10);
                                                setFormData({
                                                    ...formData,
                                                    delivered_quantity: val
                                                });
                                            }}
                                        />
                                        {errors.delivered_quantity && (
                                            <div className="text-danger fs-7">
                                                {errors.delivered_quantity}
                                            </div>
                                        )}


                                        </div>
                                        <div className="col-lg-6 mb-2">
                                            <label className="text-black font-w500 fs-7">Unit<span className="required">*</span></label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                Array.isArray(productInfo) && productInfo.length > 0
                                                    ? (productInfo[0].cooking_quantity.match(/[a-zA-Z]+/)?.[0] || '')
                                                    : ''
                                                }
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-2">
                                    <div className='row'>
                                        <div className="col-lg-6 mb-2">
                                            <label className="text-black font-w500 fs-7">Balance Quantity<span className="required">*</span></label>
                                            <input type="text" className="form-control" placeholder="Enter Balance Quantity" value={formData.balance_quantity} />
                                        </div>
                                        <div className="col-lg-6 mb-2">
                                            <label className="text-black font-w500 fs-7">Unit<span className="required">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                Array.isArray(productInfo) && productInfo.length > 0
                                                    ? (productInfo[0].cooking_quantity.match(/[a-zA-Z]+/)?.[0] || '')
                                                    : ''
                                                }
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                 <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                                    <Select
                                        placeholder={loadingStaff ? "Loading..." : "Select Staff"}
                                        value={formData.staff}
                                        onChange={selected => setFormData({ ...formData, staff: selected })}
                                        options={staffList}
                                        isMulti
                                        isDisabled={loadingStaff}
                                        classNamePrefix="react-select"
                                    />
                                    {errors.staff && <div className="text-danger fs-7">{errors.staff}</div>}
                                </div> 

                                {wastageType === "food" && (
                                    <> 
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">
                                            Average Production Cost (Wasted)<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control ${errors.average_production_cost ? 'is-invalid' : ''}`}
                                            value={formData.average_production_cost || 0}
                                            readOnly
                                        />
                                        {errors.average_production_cost && (
                                            <div className="text-danger fs-7">{errors.average_production_cost}</div>
                                        )}
                                    </div>
                                    </>

                                )}

                               <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label> 
                                    <textarea
                                        className={`form-control ${errors.wastage_reason ? 'is-invalid' : ''}`}
                                        maxLength={100}
                                        value={formData.wastage_reason}
                                        onChange={e => {
                                            let value = e.target.value;
                                            if (value.length > 0) {
                                                value = value.charAt(0).toUpperCase() + value.slice(1);
                                            }
                                            setFormData({ ...formData, wastage_reason: value });
                                        }}
                                    />

                                    {errors.wastage_reason && <div className="text-danger fs-7">{errors.wastage_reason}</div>}
                                </div>
                            </div>   
                            <div className="d-flex justify-content-end gap-3 mt-4 mb-4">
                                <button className="btn btn-sm btn-primary" onClick={handleSubmit} disabled={submitting}>
                                    {submitting ? "Adding Wastage..." : "Add Wastage"} <i className="fas fa-angle-double-right ms-2"></i>
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default AddWastage;
